const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
// console.log(`api-key `,apiKey);

export const LIVE_CHAT_COUNT = 25;

export const YOUTUBE_VIDEOS_API =
  "https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&maxResults=50&regionCode=IN&key=" +
  GOOGLE_API_KEY;

  
export const YOUTUBE_SUGGESTIONS_API =
"https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&maxResults=20&regionCode=US&key=" +
GOOGLE_API_KEY;

export const YOUTUBE_SEARCH_API =
  "http://suggestqueries.google.com/complete/search?client=firefox&ds=yt&q=";

export const SEARCH_VIDEO_BY_KEYWORD_API = "https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=20&type=video&key="+GOOGLE_API_KEY+"&q=";

export const VIDEO_STATS_API = "https://www.googleapis.com/youtube/v3/videos?part=statistics&key="+GOOGLE_API_KEY+"&id=";

export const VIDEO_COMMENTS = "https://www.googleapis.com/youtube/v3/commentThreads?part=snippet&key="+GOOGLE_API_KEY+"&videoId=";

export const BUTTONS_LIST = ["Live", "Gaming", "Songs", "Football", "Cooking", "Cricket", "News", "Trending"];


// export const YOUTUBE_SEARCH_API =
  // "http://clients1.google.com/complete/search?hl=en&output=toolbar&q=";

  // https://github.com/manosundarmanivel/youtube-api

// Live Chat >>>> Infinite Scroll >>>>>> Pagination
